<template>
  <div
    v-if="student"
    style="display: flex; flex-direction: column; justify-content: space-between; height: 100%; padding-top: 10px; padding-bottom: 10px;"
  >
    <div style="display: flex; justify-content: space-between;">
      <v-tooltip bottom v-if="isOverflowing($refs.name)">
        <template v-slot:activator="{on, attrs}">
          <div
            ref="name"
            style="color: black; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 125px;"
            v-bind="attrs"
            v-on="on"
          >
            {{ student.name }}
          </div>
        </template>
        <span>{{ student.name }}</span>
      </v-tooltip>
      <div
        v-else
        ref="name"
        style="color: black; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 125px;"
      >
        {{ student.name || '-' }}
      </div>

      <v-tooltip bottom v-if="isOverflowing($refs.school)">
        <template v-slot:activator="{on, attrs}">
          <div
            ref="school"
            style="color: #797979; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 125px;"
            v-bind="attrs"
            v-on="on"
          >
            {{ student.school }}
          </div>
        </template>
        <span>{{ student.school }}</span>
      </v-tooltip>
      <div
        v-else
        ref="school"
        style="color: #797979; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 125px;"
      >
        {{ student.school || '-' }}
      </div>
    </div>
    <div style="display: flex; justify-content: space-between">
      <div style="color: #797979; white-space: nowrap;">{{ student.dob || '-' }}</div>
      <div style="color: #797979; white-space: nowrap; ">
        {{ student.class && student.class !== '-' ? studentClass : '-' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    student: {
      type: Object,
      default: () => ({name: '-', school: '-', dob: '-', class: '-'})
    }
  },
  computed: {
    studentClass() {
      if (this.student && this.student.class) {
        return `Đang học lớp ${this.student.class}`
      }
      return '-'
    }
  },
  methods: {
    isOverflowing(ref) {
      if (ref && ref.offsetWidth < ref.scrollWidth) {
        return true
      }
      return false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  }
}
</script>
